var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconCompliantStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39453 14.374L13.1279 18.1073L19.3501 10.6406",
    stroke: "#3F8FAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4409 8.67643C29.3193 15.4823 26.321 23.5033 19.7247 26.6631C17.8058 27.6354 15.7669 28 13.7281 28C12.1689 28 10.6098 27.757 9.17063 27.2708C6.77197 26.4201 4.73312 24.9617 3.174 23.0172C2.4544 22.1665 1.85474 21.1943 1.37502 20.1004C-0.0641742 16.9406 -0.423971 13.4162 0.535488 10.1348C0.535488 9.89177 0.65542 9.64866 0.775355 9.40562C1.97468 6.00274 4.25339 3.32904 7.37163 1.62759C7.49154 1.50606 7.73143 1.38453 7.85134 1.38453C9.41045 0.655336 10.9696 0.16921 12.6487 0.0476775C13.848 -0.0738543 15.1673 0.0476774 16.3666 0.290741L16.4865 5.15201L15.8869 5.03048C13.848 4.54436 11.8091 4.78742 9.89023 5.75967C7.61152 6.97499 5.93244 8.79795 5.21285 11.1071C4.37333 13.4162 4.61319 15.9683 5.57264 18.1559C5.81251 18.5205 5.93244 18.8851 6.17231 19.2497C7.25172 20.9511 8.81083 22.1665 10.7297 22.8957C12.4088 23.5033 14.3277 23.6249 16.0068 23.1387C16.6065 23.0172 17.0862 22.7742 17.6859 22.531C20.8041 21.0727 22.6031 17.9129 22.8429 14.6315C22.8429 13.4162 22.723 12.2009 22.2433 10.9855L20.6841 11.8363L20.4443 2.11372L23.6824 4.66589L28 8.06876L26.4409 8.67643Z",
    fill: "#97E0BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconCompliantStatus);
export default __webpack_public_path__ + "static/media/TH-Icon-Compliant-Status.63b5728edc62edf56900731f1f5ac1c9.svg";
export { ForwardRef as ReactComponent };